'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../layout/slick');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)('.product_slider_main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  asNavFor: '.product_slider_small',
  responsive: [{
    breakpoint: 992,
    settings: {
      dots: true,
      customPaging: function customPaging(slider, i) {
        return '<span class="dot"></span>';
      }
    }
  }]
});

(0, _jquery2.default)('.product_slider_small').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  vertical: true,
  asNavFor: '.product_slider_main',
  focusOnSelect: true
});

var Quantity = function () {
  function Quantity(node) {
    (0, _classCallCheck3.default)(this, Quantity);

    this.input = node.querySelector('input');
    this.quantity = node.querySelector('input').value;
    this.minus = node.querySelector('.product_quantity_minus');
    this.plus = node.querySelector('.product_quantity_plus');
  }

  (0, _createClass3.default)(Quantity, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.minus.addEventListener('click', function () {
        // eslint-disable-next-line no-unused-expressions
        _this.quantity > 1 ? _this.quantity-- : _this.quantity;
        _this.updateInput();
      });

      this.plus.addEventListener('click', function () {
        _this.quantity++;
        _this.updateInput();
      });
    }
  }, {
    key: 'updateInput',
    value: function updateInput() {
      this.input.value = this.quantity;
    }
  }]);
  return Quantity;
}();

var quantityNode = document.querySelector('.product_quantity');
if (quantityNode) {
  var quantity = new Quantity(quantityNode);
  quantity.init();
}